import { Link, useLocation } from "react-router-dom";

export default function Header() {
    const location = useLocation();

    // Routes where logo should be hidden
    const hiddenRoutes = ["/login", "/verify-otp"];

    const shouldShowLogo = !hiddenRoutes.includes(location.pathname);

    return (
        <nav className="container mx-auto flex justify-center items-center px-6 pt-4">
            <div className="flex items-center">
                {shouldShowLogo && (
                    <Link to="/">
                        <img
                            src="/assets/images/logo.png"
                            alt="CrikStars"
                            className="h-20 w-auto"
                        />
                    </Link>
                )}
            </div>
        </nav>
    );
}
